import { useContext, useEffect, useRef, useState } from 'react';
import Navigation from '../../../assets/icons/trvto_navigation.png';
import ReactLoading from 'react-loading';
import './guide.css';
import { useLocation, useNavigate } from 'react-router-dom';
import TypingAnimation from '../../../components/typingAnimation/TypingAni';
import { UserAuthContext } from '../../../context/UserAuthContext';
import { debouncedHandleAutoComplete, handleAutoComplete } from '../handleAutcomplete';

// where the results page lives (v2 passes '/v2/search-result')
const DEFAULT_RESULTS_BASE = '/search-result';

const Guide = ({ className, style, handleIsSearch, type, resultsBase = DEFAULT_RESULTS_BASE }) => {
    const autoCompleteRef = useRef();
    const [searchField, setSearchField] = useState('');
    const [loading, setLoading] = useState(false);
    const [autoCompleteData, setAutoCompleteData] = useState([]);
    const [recentSearches, setRecentSearches] = useState([]);
    const [limit, setLimit] = useState(9);
    const inputFo = useRef();
    const [spanDis, setSpanDis] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuthenticated } = useContext(UserAuthContext);
    const divStyle = !isAuthenticated && window.location.pathname === '/' ? { width: '100%' } : {};
    const tripText = ['Enter the place you are looking for a guide'];

    useEffect(() => {
        const currentPath = location.pathname;
        const isSearchPage = currentPath.startsWith(`${resultsBase}/gu`);

        if (!isSearchPage) {
            setSearchField('');
        }
    }, [location, resultsBase]);

    useEffect(() => {
        if (typeof handleIsSearch === 'function' && inputFo.current) {
            inputFo.current.focus();
        }
    }, [handleIsSearch]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (autoCompleteRef.current && !autoCompleteRef.current.contains(event.target)) {
                setAutoCompleteData([]);
                setRecentSearches([]);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const headerTypingAniStyle = {
        searchContainer: {
            top: 0,
            left: 0
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch(searchField);
        }
    };

    const handleSearchType = (e) => {
        const value = e;
        const limit = window.innerWidth < 768 ? 5 : 10;
        const catlim = window.innerWidth < 768 ? 2 : 4;

        setSearchField(value);

        if (!value.trim()) {
            showRecentSearches();
            return;
        }

        setRecentSearches([]);
        debouncedHandleAutoComplete({ type, value, setAutoCompleteData, limit, catlim });
    };

    const handleSearch = async (query) => {
        const valueToSearch = query || searchField;
        if (valueToSearch.trim() !== '') {
            setLimit(9);
            setLoading(true);
            setAutoCompleteData([]);
            setSearchField('');
            setTimeout(() => {
                setLoading(false);
                navigate(`${resultsBase}/gu/${valueToSearch}`, {
                    state: { limit }
                });
            }, 300);
            if (typeof handleIsSearch === 'function') {
                handleIsSearch(false);
            }
        }
    };

    // Empty box: show this user's recent guide searches
    const showRecentSearches = () => {
        handleAutoComplete({
            type: type || 'gu',
            value: '',
            withRecent: true,
            setAutoCompleteData,
            setRecentSearches
        });
    };

    function handleSpan() {
        setSpanDis(false);
        inputFo.current.focus();
        if (!searchField.trim()) showRecentSearches();
    }

    return (
        <div style={style} className={`holidaySearchWrapper alignCenter ${className}`}>
            <div className='alignCenter'>
                <img src={Navigation} alt='trvto_navigation' />
                <div style={divStyle} className='relative alignInputWidth'>
                    <input
                        ref={inputFo}
                        value={searchField}
                        onBlur={() => setSpanDis(true)}
                        onClick={handleSpan}
                        onKeyDown={handleKeyDown}
                        onChange={(e) => handleSearchType(e.target.value)}
                        className='holidaySearch'
                    />
                    {spanDis && !searchField && (
                        <TypingAnimation
                            texts={tripText}
                            handleSpan={handleSpan}
                            seConStyle={headerTypingAniStyle.searchContainer}
                        />
                    )}
                    {!searchField.trim() && recentSearches.length > 0 && (
                        <div ref={autoCompleteRef} className='autoCompleteCon'>
                            <div className='recentSearchHeader'>Recent searches</div>
                            {recentSearches.map((item, index) =>
                                item?.place ? (
                                    <div
                                        key={`recent-${item.place}-${index}`}
                                        className='recentSearchItem'
                                        onMouseDown={(e) => {
                                            e.preventDefault();
                                            setRecentSearches([]);
                                            handleSearch(item.place);
                                        }}
                                    >
                                        <span className='recentSearchIcon'>🕘</span>
                                        <span>{item.place}</span>
                                    </div>
                                ) : null
                            )}
                        </div>
                    )}
                    {autoCompleteData.length > 0 && (
                        <div ref={autoCompleteRef} className='autoCompleteCon'>
                            {autoCompleteData.map((item, index) => (
                                <div key={index} onClick={() => handleSearch(item)}>
                                    {item}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <button type='button' className='hoilidayrSearchBtn' onClick={() => handleSearch(searchField)}>
                Search
            </button>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
        </div>
    );
};

export default Guide;
